import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { serializer } from './serializer';
import { getStore } from '@core/store';
import { Countries } from '../shared/libraries/countries';

bus.on(constants.EVENTS.PHONE.RESOLVE, (data) => {
  let phoneNumber = data.phoneNumber;
  const countryCode = data.countryCode;
  const phonePrefix = data.phonePrefix;
  const originalKey = data.originalKey || phoneNumber;

  let fullPhoneNumber = phoneNumber;

  if (phonePrefix) {
    fullPhoneNumber = phonePrefix + phoneNumber;
  } else if (countryCode) {
    const country = Countries.find(countryCode);
    if (country?.callingCode) {
      fullPhoneNumber = country.callingCode + phoneNumber;
    }
  }

  const requestId = `phoneResolve-${Date.now()}`;
  const store = getStore('phoneResolver');

  if (store.state?.phoneData?.[originalKey]?.data) {
    bus.emit(
      constants.EVENTS.PHONE.RESOLVED,
      store.state.phoneData[originalKey].data
    );
    return;
  }

  if (!phoneNumber || phoneNumber.length < 8) {
    bus.emit(constants.EVENTS.PHONE.RESOLVE_ERROR, {
      originalKey,
      message: 'invalid'
    });
    return;
  }

  bus.emit(constants.EVENTS.PHONE.RESOLVING, { phoneNumber: originalKey });

  let url = `${constants.ENDPOINTS.PHONE.RESOLVE}`;
  url = url.replace(/{phone}/, fullPhoneNumber);

  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res, {
        phoneNumber: fullPhoneNumber
      });
      if (parsed.success) {
        bus.emit(constants.EVENTS.PHONE.RESOLVED, {
          ...parsed.data,
          originalKey
        });
      } else {
        bus.emit(constants.EVENTS.PHONE.RESOLVE_ERROR, {
          ...parsed,
          originalKey
        });
      }
    }
  });
});
